import { memo, useEffect, useRef } from "react";

const FormikStateObserver = memo(({ dirty, onDirtyChange }) => {
    const prevDirtyRef = useRef(dirty);

    useEffect(() => {
        if (prevDirtyRef.current !== dirty) {
            if (typeof onDirtyChange === 'function') {
                onDirtyChange(dirty);
            }

            prevDirtyRef.current = dirty;
        }

    }, [dirty, onDirtyChange]);

    return null;
});

export default FormikStateObserver;